import React from 'react';
import { ContactHero } from './ContactHero';
import { ContactForm } from './ContactForm';
export function Contact() {
  return <div className="min-h-screen w-full bg-white" data-id="element-231">
      <section className="py-20" data-id="element-232">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
          <ContactHero data-id="element-234" />
          <ContactForm data-id="element-235" />
        </div>
      </section>
    </div>;
}